﻿// IMPORTANT:  jquery must be imported before any other imports in order to ensure that angular utilizes jQuery and not JQLite

declare var global: any; // global is a variable that is created by browserify
import jQuery = require('jquery');
global.jQuery = jQuery;
global.$ = jQuery; // this is a hack, angular UI router has an issue 
import moment = require('moment');
global.moment = moment;

import "bootstrap";
import "angular";
import "angular-ui-router";
import "angular-ui-grid";
import "angular-ui-mask";
import "angular-animate";
import "angular-sanitize";
import "angular-perfect-scrollbar-2";
import "angular-translate"; // required by ghiscoding.validation (form validation library)
import "angular-translate-loader-static-files"; // see: https://github.com/angular-translate/angular-translate/issues/333
import 'angular-ui-bootstrap';
import "./vendor/angular-validation-ghiscoding";
import "./vendor/autoNumeric";
import "./vendor/angular-typed"; // customized from npm package
import "ng-focus-if";
import "angular-clipboard";
import "angulartics";
import "angulartics-google-tag-manager";
import "angular-auth0";

/** IE9, IE10 and IE11 requires all of the following polyfills. **/
import 'core-js/es6/symbol';
import 'core-js/es6/object';
import 'core-js/es6/function';
import 'core-js/es6/parse-int';
import 'core-js/es6/parse-float';
import 'core-js/es6/number';
import 'core-js/es6/math';
import 'core-js/es6/string';
import 'core-js/es6/date';
import 'core-js/es6/array';
import 'core-js/es6/regexp';
import 'core-js/es6/map';
import 'core-js/es6/weak-map';
import 'core-js/es6/set';
import 'core-js/es6/promise';